import type { WorkspaceInfo } from '../types';

export interface ImportPatentsStatus extends WorkspaceInfo {
    /**
     * 任务ID
     */
    taskId: string;
    /**
     * 文件夹ID
     */
    folderId: string;
    /**
     * 工作空间ID
     */
    spaceId: string;
    /**
     * 文件夹路径
     */
    folderPath: string;
    /**
     * 异步任务ID
     */
    asyncId: string;
    /**
     * 状态
     */
    status: string;
    /**
     * 总专利数
     */
    totalPatents: number;
    /**
     * 估计时间
     */
    estimatedMinutes: number;
    /**
     * 批量大小
     */
    batchSize: number;
    /**
     * 处理专利数
     */
    processedPatents: number;
    /**
     * 完成专利数
     */
    completedPatents: number;
    /**
     * 失败专利数
     */
    failedPatents: number;
    /**
     * 失败专利ID
     */
    failedPatentIds: string[];
    /**
     * 进度
     */
    progress: number;
    /**
     * 新完成专利ID
     */
    newCompletedPatentIds: string[];
    /**
     * 新结果
     */
    newResults: any[];
    /**
     * 估计剩余时间
     */
    estimatedRemainingMinutes: number;
    /**
     * 当前时间戳
     */
    currentTimestamp: number;
}

export interface ImportPatentsOptions {
    /**
     * 文件夹ID
     */
    folderId?: string;
    /**
     * 工作空间ID
     */
    spaceId?: string;
    /**
     * 批量大小
     */
    batchSize?: number;
    /**
     * 取消信号
     */
    signal?: AbortSignal;
    /**
     * 导入专利开始事件
     */
    onImportPatentsStart?: (status: ImportPatentsStatus) => Promise<void>;
    /**
     * 导入专利进度事件
     */
    onImportPatentsProgress?: (status: ImportPatentsStatus) => Promise<void>;
    /**
     * 导入专利完成事件
     */
    onImportPatentsComplete?: (status: ImportPatentsStatus) => Promise<void>;
}


export interface FtoReportImportPatentsRepository {
    /**
     * 导入专利
     * @param taskId 任务ID
     * @param options 导入专利选项
     * @returns 导入专利异步任务状态
     */
    importPatents(taskId: string, options?: ImportPatentsOptions): Promise<ImportPatentsStatus>;
}

export const FtoReportImportPatentsRepository = Symbol.for('FtoReportImportPatentsRepository');
